import { useEffect, type ReactNode } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { PublicFeedbackPage } from '../pages/PublicFeedbackPage';
import { PublicStatusPage } from '../pages/public/PublicStatusPage';

function LegacyAppRedirect({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
}

function LegacyAuthRedirect() {
  const location = useLocation();
  return <Navigate to={`/login${location.search}${location.hash}`} replace />;
}

function ContactSalesRedirect() {
  const location = useLocation();

  useEffect(() => {
    window.location.href = `https://perspectify.dev/contact-sales${location.search}${location.hash}`;
  }, [location.hash, location.search]);

  return null;
}

export function RootRouter({
  authEntrypoint,
}: {
  authEntrypoint: ReactNode;
}) {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={authEntrypoint} />
      <Route path="/login/:authPath" element={authEntrypoint} />
      <Route path="/auth" element={<LegacyAuthRedirect />} />
      <Route path="/auth/:authPath" element={<LegacyAuthRedirect />} />
      <Route path="/contact-sales" element={<ContactSalesRedirect />} />
      <Route path="/feedback/:projectId/:token" element={<PublicFeedbackPage />} />
      <Route path="/status/:slug" element={<PublicStatusPage />} />
      <Route path="/app/*" element={authEntrypoint} />
      <Route path="/logs" element={<LegacyAppRedirect to="/app/logs" />} />
      <Route path="/sessions" element={<LegacyAppRedirect to="/app/sessions" />} />
      <Route path="/feedback" element={<LegacyAppRedirect to="/app/feedback" />} />
      <Route path="/product" element={<LegacyAppRedirect to="/app/product" />} />
      <Route path="/health" element={<LegacyAppRedirect to="/app/health" />} />
      <Route path="/status-pages" element={<LegacyAppRedirect to="/app/status-pages" />} />
      <Route path="/settings" element={<LegacyAppRedirect to="/app/settings" />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
